export const brandColors = {
  good: '#43A047',
  safe: '#28A745',
  normal: '#FFC107',
  warning: '#FF9800',
  danger: 'rgba(244, 67, 54, 1)',
  muted:  '#E0E0E0',
  unused:  '#999',
}

export const chartSettings = {
  height: '250px'
}